import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { LOGO_URL_WHITE } from "../lib/utils";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-forest text-white">
      <div className="container-flow py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="inline-block">
            <img src={LOGO_URL_WHITE} alt="FLOW" className="h-11 w-auto object-contain" />
          </div>
          <p className="mt-6 text-white/80 text-base max-w-sm leading-relaxed">
            {t("footer.tagline")}
          </p>
          <div className="mt-8 flex items-center gap-4">
            <a
              data-testid="footer-instagram"
              href="https://instagram.com/flow_natation_cyclisme"
              target="_blank"
              rel="noreferrer"
              className="w-11 h-11 border border-white/30 flex items-center justify-center hover:bg-burnt hover:border-burnt transition-colors"
            >
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-overline !text-energy mb-5">{t("footer.nav")}</p>
          <ul className="space-y-3 font-body text-white/85">
            <li><Link to="/" className="hover:text-energy">{t("nav.home")}</Link></li>
            <li><Link to="/services" className="hover:text-energy">{t("nav.services")}</Link></li>
            <li><Link to="/notre-histoire" className="hover:text-energy">{t("nav.about")}</Link></li>
            <li><Link to="/tarifs" className="hover:text-energy">{t("nav.pricing")}</Link></li>
            <li><Link to="/reservation" className="hover:text-energy">{t("nav.booking")}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-overline !text-energy mb-5">{t("footer.contact")}</p>
          <ul className="space-y-4 font-body text-white/85">
            <li className="flex items-start gap-3">
              <Mail size={18} className="mt-1 text-energy" />
              <a href="mailto:flownatationcyclisme@gmail.com" data-testid="footer-email" className="hover:text-energy break-all">flownatationcyclisme@gmail.com</a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={18} className="mt-1 text-energy" />
              <a href="tel:+14382702682" data-testid="footer-phone" className="hover:text-energy">(438) 270-2682</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={18} className="mt-1 text-energy" />
              <span>Montréal, Québec · Canada</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="container-flow py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-white/60 text-sm">
          <p>© {new Date().getFullYear()} FLOW Natation & Cyclisme. {t("footer.rights")}</p>
          <div className="flex items-center gap-5">
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="text-white/40 hover:text-energy transition-colors text-xs"
            >
              Admin
            </Link>
            <p className="font-heading uppercase tracking-widest text-xs">Made with discipline.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
